/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRecommendations = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9.996 16v2H2v-2zM22 6v8H2V6zM8.094 7.144l-3.026 3.027-1.165-1.166L2.49 10.42 5.068 13l4.439-4.441zM20.001 8h-4v4.001h4zm-5.997 0H9.996v4.001h4.008z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRecommendations as Recommendations };
